import { ReactNode } from 'react'

type TextBlock = {
  content: {
    value: string
    box?: string
    className?: string
  }
}

type ReactBlock = {
  children: ReactNode
  wordCount: number
}

type Value = TextBlock | ReactBlock

export function isTextBlock(value: Value): value is TextBlock {
  return 'content' in value && value.content !== undefined
}

export function rt(value: Value): RichText {
  return new RichText(value)
}

export class RichText {
  value: Value

  constructor(value: Value) {
    this.value = value
  }

  length(): number {
    if (isTextBlock(this.value)) {
      return this.value.content.value.split(' ').length
    } else {
      return this.value.wordCount
    }
  }
}
